import { render } from "./BaseWaiter.vue?vue&type=template&id=012755be&scoped=true"
import script from "./BaseWaiter.vue?vue&type=script&lang=js"
export * from "./BaseWaiter.vue?vue&type=script&lang=js"

import "./BaseWaiter.vue?vue&type=style&index=0&id=012755be&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012755be"]])

export default __exports__